<section class="hero" id="hero">
  <div class="wrap">
    <!-- <span class="eyebrow" appReveal style="--d: 0s"
      ><span class="dot"></span> Always-On AI Customer Engagement
      <span class="tag">v2.0</span></span
    > -->
    <h1 appReveal style="--d: 0.08s">
      Enable customer interaction with seamless
      <span class="hl"
        >AI &amp; human<svg
          viewBox="0 0 200 14"
          preserveAspectRatio="none"
          fill="none"
        >
          <path
            d="M2 9C40 4 120 3 198 7"
            stroke="currentColor"
            stroke-width="3.5"
            stroke-linecap="round"
          /></svg
      ></span>
      assistance
    </h1>
    <p class="lead" appReveal style="--d: 0.16s">
      ConnectNow combines AI-powered Video, Voice, and Chat with human
      ConnectNow blends AI and human interactions across Video, Voice, and Chat
      to drive engagement, increase conversions, and deliver personalized
      customer experiences.
    </p>
    <div class="hero-cta" appReveal style="--d: 0.28s">
      <a
        href="https://dashboard.connectnow.ai/#/auth/signup"
        class="btn btn-accent"
         id="start_now_btn"
        (click)="onStartNowClicked()"
        >Start Now
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 12h14M13 6l6 6-6 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <a id="request_demo_click" class="btn btn-outline" (click)="onContactUsClicked()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            stroke-width="2"
          />
          <path d="M10 8l5 4-5 4V8z" fill="currentColor" />
        </svg>
        Request a Demo
      </a>
    </div>
    <p class="slogan" appReveal style="--d: 0.34s">
      <b>Always-On.</b> Always Smart. <b>Always Selling.</b>
    </p>

    <!-- EMBED VIDEO -->
    <div class="video-stage" appReveal style="--d: 0.42s">
      <div class="glow-ring"></div>
      <div class="video-chip chip-1">
        <span class="ic"
          ><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 8l5-3v14l-5-3M3 6h12v12H3z"
              stroke="#fff"
              stroke-width="1.8"
              stroke-linejoin="round"
            /></svg
        ></span>
        <div>Video<small>Live virtual experience</small></div>
      </div>
      <div class="video-chip chip-2">
        <span class="ic"
          ><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 4a3 3 0 013 3v5a3 3 0 01-6 0V7a3 3 0 013-3zM6 11a6 6 0 0012 0M12 17v3"
              stroke="#fff"
              stroke-width="1.8"
              stroke-linecap="round"
            /></svg
        ></span>
        <div>Voice<small>AI call agents</small></div>
      </div>
      <div class="video-chip chip-3">
        <span class="ic"
          ><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 5h16v11H8l-4 3V5z"
              stroke="#fff"
              stroke-width="1.8"
              stroke-linejoin="round"
            /></svg
        ></span>
        <div>Chat<small>24/7 instant replies</small></div>
      </div>
      <div class="video-frame">
        <div class="vid-bar">
          <span class="d"></span><span class="d"></span><span class="d"></span>
          <span class="url">connectnow.ai — see it in action</span>
        </div>
        <div class="vid-wrap">
          <iframe
            src="https://www.youtube-nocookie.com/embed/e1OnUbxnHiw?si=-dnf1VonvC-aa_6v&amp;controls=1&amp;rel=0&amp;loop=1"
            title="ConnectNow demo"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
            "
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <!-- trust -->
    <div class="trust" appReveal>
      <p>Multimodal · Omnichannel · Human-in-the-loop</p>
      <div class="modes">
        <span class="mode-pill"
          ><svg viewBox="0 0 24 24" fill="none">
            <path
              d="M15 8l5-3v14l-5-3M3 6h12v12H3z"
              stroke="var(--accent)"
              stroke-width="1.8"
              stroke-linejoin="round"
            /></svg
          >Video Agents</span
        >
        <span class="mode-pill"
          ><svg viewBox="0 0 24 24" fill="none">
            <path
              d="M5 4h4l2 5-3 2a11 11 0 005 5l2-3 5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z"
              stroke="var(--accent)"
              stroke-width="1.8"
              stroke-linejoin="round"
            /></svg
          >Voice Agents</span
        >
        <span class="mode-pill"
          ><svg viewBox="0 0 24 24" fill="none">
            <path
              d="M4 5h16v11H8l-4 3V5z"
              stroke="var(--accent)"
              stroke-width="1.8"
              stroke-linejoin="round"
            /></svg
          >Chat Agents</span
        >
        <span class="mode-pill"
          ><svg viewBox="0 0 24 24" fill="none">
            <path
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM4 21a8 8 0 0116 0"
              stroke="var(--accent)"
              stroke-width="1.8"
              stroke-linecap="round"
            /></svg
          >Human Handoff</span
        >
      </div>
    </div>
  </div>
</section>
